import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Image, Navbar, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { BiLeftArrowAlt } from "react-icons/bi";
import { HiArrowLeft } from 'react-icons/hi';
import Loader from "react-js-loader";
import { useMediaQuery } from 'react-responsive';
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../Layout/Header";
import SidebarMenu from "../../Layout/SidebarMenu";
import { getEndpointUrl, getTimestamp } from "../../Utils/Common";
import iconAccu from "../../icons/accumulator.png";
import iconCondtioner from "../../icons/air-conditioner.png";
import iconCabin from "../../icons/cabin.png";
import iconSuspen from "../../icons/car-repair.png";
import iconExterior from "../../icons/car-services.png";
import iconEngine from "../../icons/engine.png";
import iconFluida from "../../icons/fluida.png";
import iconFrame from "../../icons/frame-service.png";
import iconDocument from "../../icons/inspection.png";
import iconBan from "../../icons/tire-pressure.png";
import iconWiper from "../../icons/wiper.png";
import iconBook from "../../icons/contract.png";
import { FaCheck, FaExternalLinkAlt, FaEye, FaTimes } from "react-icons/fa";
import { SpeedDial } from 'primereact/speeddial';
import ModalFinishInspection from "./ModalFinishInspection";

const MainForm = () => {
    const [isLoading, setLoading] = useState(true);

    const navigate = useNavigate();

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const params = useParams();

    const [accesToken] = useState(JSON.parse(localStorage.getItem('credentials')) || []);

    const [submited, setSubmited] = useState([]);

    const [entryAccu, setEntryAccu] = useState({});
    const [entryCondtioner, setEntryCondtioner] = useState({});
    const [entryCabin, setEntryCabin] = useState({});
    const [entrySuspen, setEntrySuspen] = useState({});
    const [entryExterior, setEntryExterior] = useState({});
    const [entryEngine, setEntryEngine] = useState({});
    const [entryFluida, setEntryFluida] = useState({});
    const [entryDocument, setEntryDocument] = useState({});
    const [entryBan, setEntryBan] = useState({});
    const [entryWiper, setEntryWiper] = useState({});
    const [entryFrame, setEntryFrame] = useState({});
    const [entryPemeriksaan, setEntryPemeriksaan] = useState({});

    const [devStatus, setDevStatus] = useState('pending');

    const [confirmSetStatusDialog, setConfirmSetStatusDialog] = useState(false);

    const fetchData = useCallback(async (id) => {
        setLoading(true);

        fetch(getEndpointUrl() + `/checkpoint/count_all/${id}?v=${getTimestamp()}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`
            })
        }).then(response => response.json()).then(json => {

            if (json.status == 'ok') {
                setSubmited(json.results);

                setEntryAccu(json.results.filter(item => item.category == 'battery').at(0) || {});
                setEntryCondtioner(json.results.filter(item => item.category == 'air-conditioner').at(0) || {});
                setEntryCabin(json.results.filter(item => item.category == 'interior').at(0) || {});
                setEntrySuspen(json.results.filter(item => item.category == 'suspensions').at(0) || {});
                setEntryExterior(json.results.filter(item => item.category == 'exterior').at(0) || {});
                setEntryEngine(json.results.filter(item => item.category == 'mesin').at(0) || {});
                setEntryFluida(json.results.filter(item => item.category == 'fluida').at(0) || {});
                setEntryDocument(json.results.filter(item => item.category == 'document').at(0) || {});
                setEntryBan(json.results.filter(item => item.category == 'ban-rem-velg').at(0) || {});
                setEntryWiper(json.results.filter(item => item.category == 'elektrikal-dan-fitur').at(0) || {});
                setEntryFrame(json.results.filter(item => item.category == 'rangka').at(0) || {});
                setEntryPemeriksaan(json.results.filter(item => item.category == 'hasil-pemeriksaan').at(0) || {});
            }

            setLoading(false);
        }).catch(error => {
            setLoading(true);
        });
    }, []);

    useEffect(() => {
        fetchData(params.offer_id);
    }, [params]);

    useEffect(() => {
    }, [entryAccu, entryCondtioner, entryCabin, entrySuspen, entryExterior, entryEngine, entryFluida, entryDocument, entryBan, entryWiper, entryFrame]);

    const getColorEntry = (entry, totalCheck) => {
        if (Object.keys(entry).length) {
            if (entry.totalEntry < totalCheck) {
                return 'warning';
            } else {
                return 'success';
            }
        }
        return 'secondary';
    }

    const onCallback = useCallback((e) => {

    }, []);

    return (
        <>
            <Helmet>
                <title>Form Inspeksi Kendaraan</title>
            </Helmet>
            <div className="d-block d-sm-none">
                <Navbar expand="lg" className="mainNavbar border-bottom mb-3" sticky="top">
                    <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                        <HiArrowLeft />
                    </a>
                    <strong className="me-auto navTitle">Form Inspeksi Kendaraan</strong>
                    <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                </Navbar>
                <div className="fixed-bottom">
                    <SpeedDial model={[
                        {
                            label: 'Selesaikan Inspesi',
                            icon: 'pi pi-check',
                            command: () => {
                                setDevStatus('selesai');
                                setConfirmSetStatusDialog(true);
                            }
                        },
                        {
                            label: 'Batalkan Inspesi',
                            icon: 'pi pi-times',
                            command: () => {
                                setDevStatus('cancel');
                                setConfirmSetStatusDialog(true);
                            }
                        },
                        {
                            label: 'Lihat Hasil Inspeksi',
                            icon: 'pi pi-external-link',
                            command: () => navigate(`/inspeksi/detil/${params.offer_id}`)
                        }
                    ]} radius={80} type="quarter-circle" direction="up-left" style={{ right: 30, bottom: 30 }} buttonClassName="p-button-secondary" />
                </div>
            </div>
            <SidebarMenu show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
            <div className="d-none d-sm-inline">
                <Header />
            </div>
            <Container className="mt-4 mb-5">
                <div className="d-none d-sm-inline">
                    <Row className="mb-4">
                        <Col md={12} className="mb-3">
                            <strong className="me-auto navTitle">Form Inspeksi</strong>
                        </Col>
                        <Col md={12}>
                            <Button variant="secondary" onClick={() => navigate(-1)} className="pe-3"><BiLeftArrowAlt /> Kembali</Button>
                            <Button variant="outline-secondary" onClick={() => navigate(`/inspeksi/detil/${params.offer_id}`)} className="ms-3 pe-3">Lihat Hasil Inspeksi <FaExternalLinkAlt className="ms-2" /></Button>
                            <Button variant="outline-success" onClick={() => {
                                setDevStatus('selesai');
                                setConfirmSetStatusDialog(true);
                            }} className="ms-3 pe-3"><FaCheck /> Selesaikan Inspeksi </Button>
                            <Button variant="outline-danger" onClick={() => {
                                setDevStatus('cancel');
                                setConfirmSetStatusDialog(true);
                            }} className="ms-3 pe-3"><FaTimes /> Batalkan Inspeksi </Button>
                        </Col>
                    </Row>
                </div>
                {isLoading ?
                    <div className="text-center mt-5">
                        <Loader type="bubble-scale" bgColor={"#EF9A9A"} size={100} />
                    </div> :
                    <Row>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${params.offer_id}/document`} className={`btn btn-outline-${getColorEntry(entryDocument, 3)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconBook} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryDocument).length ? entryDocument.totalEntry : 0}/3</div>
                                    <div>Dokumen Kendaraan</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${params.offer_id}/elektrikal-dan-fitur`} className={`btn btn-outline-${getColorEntry(entryWiper, 41)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconWiper} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryWiper).length ? entryWiper.totalEntry : 0}/41</div>
                                    <div>Elektrikal dan Fitur</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${params.offer_id}/interior`} className={`btn btn-outline-${getColorEntry(entryCabin, 39)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconCabin} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryCabin).length ? entryCabin.totalEntry : 0}/39</div>
                                    <div>Interior</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${params.offer_id}/mesin`} className={`btn btn-outline-${getColorEntry(entryEngine, 9)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconEngine} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryEngine).length ? entryEngine.totalEntry : 0}/9</div>
                                    <div>Mesin</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${params.offer_id}/fluida`} className={`btn btn-outline-${getColorEntry(entryEngine, 9)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconFluida} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryFluida).length ? entryFluida.totalEntry : 0}/9</div>
                                    <div>Fluida</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${params.offer_id}/air-conditioner`} className={`btn btn-outline-${getColorEntry(entryCondtioner, 5)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconCondtioner} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryCondtioner).length ? entryCondtioner.totalEntry : 0}/5</div>
                                    <div>Pendingin / AC</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${params.offer_id}/battery`} className={`btn btn-outline-${getColorEntry(entryAccu, 1)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconAccu} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryAccu).length ? entryAccu.totalEntry : 0}/1</div>
                                    <div>Battery / AKI</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${params.offer_id}/exterior`} className={`btn btn-outline-${getColorEntry(entryExterior, 33)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconExterior} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryExterior).length ? entryExterior.totalEntry : 0}/33</div>
                                    <div>Exterior</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${params.offer_id}/rangka`} className={`btn btn-outline-${getColorEntry(entryFrame, 6)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconFrame} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryFrame).length ? entryFrame.totalEntry : 0}/6</div>
                                    <div>Frame / Rangka</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${params.offer_id}/suspensions`} className={`btn btn-outline-${getColorEntry(entrySuspen, 10)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconSuspen} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entrySuspen).length ? entrySuspen.totalEntry : 0}/10</div>
                                    <div>Suspensi / Kaki-kaki</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${params.offer_id}/ban-rem-velg`} className={`btn btn-outline-${getColorEntry(entryBan, 10)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconBan} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryBan).length ? entryBan.totalEntry : 0}/10</div>
                                    <div>Ban, Rem, Velg</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${params.offer_id}/hasil-pemeriksaan`} className={`btn btn-outline-${getColorEntry(entryPemeriksaan, 7)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconDocument} width={60} />
                                    </div>
                                    <div className="mt-2">{entryPemeriksaan.totalEntry}/7</div>
                                    <div>Hasil Pemeriksaan</div>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                }
            </Container>
            <ModalFinishInspection param={params.offer_id} onCallback={(e) => onCallback(e)} show={confirmSetStatusDialog} close={() => setConfirmSetStatusDialog(false)} status={devStatus} />
        </>
    );
}

export default MainForm;
